import React, { useEffect, useState, useCallback } from "react";
import { useOrganizationsStore } from "@/stores/organizationsStore";
import { OrganizationWithUsers } from "@/lib/types";
import { OrganizationCallList } from "@/components/OrganizationCallList";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Dialog, DialogTrigger, DialogContent } from "@/components/ui/dialog";
import CreateCallForm from "@/components/CreateCallForm";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import Papa, { ParseError, ParseResult } from "papaparse";
import BulkCallForm from "@/components/BulkCallForm";

function CallsPage() {
  const { selectedOrganizationId } = useOrganizationsStore();
  const [isCreateCallDialogOpen, setIsCreateCallDialogOpen] = useState(false);
  const [callCreatedFlag, setCallCreatedFlag] = useState(false);

  const handleCallCreated = () => {
    setIsCreateCallDialogOpen(false);
    setCallCreatedFlag((prev) => !prev);
  };

  if (!selectedOrganizationId) {
    return <div>Loading...</div>;
  }

  return (
    <Card className="w-full mt-4 border-none shadow-none">
      <CardHeader className="flex flex-row justify-between items-center">
        <CardTitle>Calls</CardTitle>
        <div className="flex gap-2">
          <Dialog>
            <DialogTrigger asChild>
              <Button>Upload CSV</Button>
            </DialogTrigger>
            <DialogContent>
              <BulkCallForm
                organizationId={selectedOrganizationId}
                onSuccess={() => {
                  setCallCreatedFlag((prev) => !prev);
                }}
              />
            </DialogContent>
          </Dialog>
          <Dialog
            open={isCreateCallDialogOpen}
            onOpenChange={setIsCreateCallDialogOpen}
          >
            <DialogTrigger asChild>
              <Button>Create Call</Button>
            </DialogTrigger>
            <DialogContent>
              <CreateCallForm
                organizationId={selectedOrganizationId}
                onSuccess={handleCallCreated}
              />
            </DialogContent>
          </Dialog>
        </div>
      </CardHeader>
      <CardContent>
        <OrganizationCallList
          organizationId={selectedOrganizationId}
          onCallCreated={callCreatedFlag}
        />
      </CardContent>
    </Card>
  );
}

export default CallsPage;
